import { render, staticRenderFns } from "./ProjectWalletTakt.view.vue?vue&type=template&id=0796a446&"
import script from "./ProjectWalletTakt.view.vue?vue&type=script&lang=js&"
export * from "./ProjectWalletTakt.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports